const TRANSLATIONS = {
  en: {
    'language.label': 'Language',
    'language.en': 'English',
    'language.uk': 'Ukrainian',
    'language.enShort': 'EN',
    'language.ukShort': 'UK',
    'title.parameters': 'Parameters',
    'label.coffeeWeight': 'Coffee weight:',
    'label.tasteControls': 'Taste controls:',
    'taste.brighter': 'Brighter',
    'taste.sweeter': 'Sweeter',
    'strength.light': 'Light',
    'strength.medium': 'Medium',
    'strength.strong': 'Strong',
    'title.data': 'Data',
    'data.coffee': 'Coffee',
    'data.water': 'Water',
    'data.temperature': 'Temperature',
    'title.instructions': 'Instructions',
    'button.start': 'Start',
    'button.pause': 'Pause',
    'button.reset': 'Reset',
    'label.enableSound': 'Enable sound notifications',
    'table.totalTime': 'Total time',
    'table.waterPerPour': 'Water per pour',
    'table.totalWater': 'Total water',
    'action.removeDripper': 'Remove the dripper',
    'desc.title': '4:6 brewing method',
    'desc.subtitle': 'How to brew with the "4:6 method"',
    'desc.step.rinse': 'Rinse the paper filter with hot water.',
    'desc.step.divide': 'Divide the total amount of water to be poured into 40% and 60%.',
    'desc.tipsTitle': 'Tips',
    'desc.tip.grind': 'Choose your preferred grind size. (Adjust the coarseness so that water almost completely drips within this total time.)',
    'desc.tip.firstPour': 'The role of the first pour is to moisten the grounds.',
    'desc.tip.wait': 'Do not make the next pour until the water completely drips through.',
    'status.removeNow': 'Remove the dripper now.',
    'status.pourNow': 'Pour {index} now ({amount}{unit}).',
    'status.pressStart': 'Press Start when you begin brewing.',
    'status.paused': 'Timer paused.',
    'status.nextPourIn': 'Next pour in {seconds}{unit}.',
    'status.removeIn': 'Remove dripper in {seconds}{unit}.',
    'unit.g': 'g',
    'unit.ml': 'ml',
    'time.minuteShort': 'm',
    'time.secondShort': 's',
  },
  uk: {
    'language.label': 'Мова',
    'language.en': 'Англійська',
    'language.uk': 'Українська',
    'language.enShort': 'EN',
    'language.ukShort': 'УК',
    'title.parameters': 'Параметри',
    'label.coffeeWeight': 'Вага кави:',
    'label.tasteControls': 'Керування смаком:',
    'taste.brighter': 'Яскравіше',
    'taste.sweeter': 'Солодше',
    'strength.light': 'Легка',
    'strength.medium': 'Середня',
    'strength.strong': 'Міцна',
    'title.data': 'Дані',
    'data.coffee': 'Кава',
    'data.water': 'Вода',
    'data.temperature': 'Температура',
    'title.instructions': 'Інструкції',
    'button.start': 'Старт',
    'button.pause': 'Пауза',
    'button.reset': 'Скинути',
    'label.enableSound': 'Увімкнути звукові сповіщення',
    'table.totalTime': 'Загальний час',
    'table.waterPerPour': 'Вода на пролив',
    'table.totalWater': 'Загалом води',
    'action.removeDripper': 'Зніміть дріпер',
    'desc.title': 'Метод заварювання 4:6',
    'desc.subtitle': 'Як заварювати методом "4:6"',
    'desc.step.rinse': 'Промийте паперовий фільтр гарячою водою.',
    'desc.step.divide': 'Розділіть загальну кількість води для проливів на 40% і 60%.',
    'desc.tipsTitle': 'Поради',
    'desc.tip.grind': 'Оберіть бажаний помел. (Налаштуйте грубість так, щоб вода майже повністю стікала за цей загальний час.)',
    'desc.tip.firstPour': 'Роль першого проливу - зволожити мелену каву.',
    'desc.tip.wait': 'Не робіть наступний пролив, доки вода повністю не пройде крізь фільтр.',
    'status.removeNow': 'Зніміть дріпер зараз.',
    'status.pourNow': 'Пролив {index} зараз ({amount}{unit}).',
    'status.pressStart': 'Натисніть "Старт", коли почнете заварювати.',
    'status.paused': 'Таймер на паузі.',
    'status.nextPourIn': 'Наступний пролив через {seconds} {unit}.',
    'status.removeIn': 'Зніміть дріпер через {seconds} {unit}.',
    'unit.g': 'г',
    'unit.ml': 'мл',
    'time.minuteShort': 'хв',
    'time.secondShort': 'с',
  },
};

export default TRANSLATIONS;
